import { EditorModule } from '@tinymce/tinymce-angular';
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { ReactiveFormsModule } from "@angular/forms";

import { TinyMCEWidget } from "./tinymce.widget";
import { TinyMCEValueAccessor } from "./tinymce.valueaccessor";

@NgModule({
    imports: [ReactiveFormsModule, EditorModule],
    declarations: [ TinyMCEWidget, TinyMCEValueAccessor],
    entryComponents: [TinyMCEWidget],
    exports: [TinyMCEWidget, TinyMCEValueAccessor],
})
export class Ng2SFTinyMCEModule { }
